import { Box, Button } from "@mantine/core";
import { ContextModalProps } from "@mantine/modals";
import React from "react";
import { useTranslation } from "react-i18next";

export const InfoModal = ({ context, id, innerProps }: ContextModalProps<{ modalBody: React.ReactNode }>) => {
	const { t } = useTranslation();

	return (
		<>
			<Box>{innerProps.modalBody}</Box>
			<Button fullWidth mt="md" onClick={() => context.closeModal(id)}>
				{t("button_close")}
			</Button>
		</>
	);
};
